var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"button is-info is-hidden-mobile",attrs:{"disabled":_vm.disabled},on:{"click":_vm.action}},[(_vm.printer)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('createBarcode', {amount: _vm.stones.length}))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('connectPrinter'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }